import { useMutation, useQuery } from '@apollo/client';
import { useNavigate, useParams } from 'react-router-dom';
import { useToast } from '@chakra-ui/react';
import { EventFieldsFragment, GetEventDocument, UpdateEventDocument } from '~/gql/ucpw/graphql';
import { useEffect } from 'react';

export function DoneEvent() {
    const { terminId } = useParams();
    const { data, loading: queryLoading } = useQuery(GetEventDocument, {
        variables: { id: parseInt(terminId!) },
        context: { clientName: 'ucpw' },
        skip: !terminId,
    });
    const termin = data?.item?.item as EventFieldsFragment;
    const toast = useToast();
    const naviate = useNavigate();

    const [updateEvent, { loading: mutationLoading }] = useMutation(UpdateEventDocument, {
        context: { clientName: 'ucpw' },
        refetchQueries: [
            {
                query: GetEventDocument,
                context: { clientName: 'ucpw' },
                variables: { id: parseInt(terminId!) },
            },
        ],
    });

    const loading = queryLoading && mutationLoading;

    useEffect(() => {
        if (termin && termin.erledigt) {
            toast({
                title: 'Termin war bereits erledigt',
                status: 'success',
                duration: 2000,
                isClosable: true,
            });
            naviate(`/projekte/termine/person`);
        } else if (termin && !termin.erledigt) {
            updateEvent({
                variables: {
                    id: termin.id,
                    version: termin.version,
                    data: {
                        mitarbeiterIdSachbearbeiter: termin.mitarbeiterIdSachbearbeiter,
                        typSnippetId: termin.typSnippetId,
                        bemerkung: termin.bemerkung,
                        dauer: termin.dauer,
                        geplant: termin.geplant,
                        prio: termin.prio,
                        subprojektId: termin.subprojektId,
                        erledigt: new Date().toISOString(),
                        confirmed: false,
                    },
                    forceOverwrite: true,
                },
            })
                .then(() => {
                    toast({
                        title: 'Termin erledigt',
                        status: 'success',
                        duration: 2000,
                        isClosable: true,
                    });
                })
                .finally(() => {
                    naviate(`/projekte/termine/person`);
                });
        }
    }, [loading, termin, updateEvent]);

    return null;
}
